export default "__VITE_ASSET__ff54ca84__"